<template>
  <div class="LessonEntityDetails__Component">
    <FieldInlineText label="שם" @onChange="onChange" v-model="model.name" />

    <FieldInlineSelect label="אזור" @onChange="onChange" :filterable="true" :clearable="true" :optionsAsync="getRegions"
      v-model="model.lecturesRegionsId" />

    <FieldInlineText label="עיר" @onChange="onChange" v-model="model.city" />

    <FieldInlineText label="כתובת" @onChange="onChange" v-model="model.address" />

    <FieldInlineText type="number" label="קיבולת" @onChange="onChange" v-model="model.capacity" />

    <FieldInlineText type="number" label="קו צהוב" @onChange="onChange" v-model="model.capacityYellowLine" />

    <FieldInlineText label="הערה לתלמיד" @onChange="onChange" v-model="model.userNote" />

    <FieldInlineText label="הערה פנימית" @onChange="onChange" v-model="model.editorNode" />

    <FieldInlineText label="סוגי שולחנות" @onChange="onChange" v-model="model.tablesTypes" />

    <FieldInlineText v-mask="'##:##:##'" label="פתוח משעה" @onChange="onChange" v-model="model.openFrom" />

    <FieldInlineText v-mask="'##:##:##'" label="פתוח עד שעה" @onChange="onChange" v-model="model.openUntil" />

    <FieldInlineText label="איש קשר" @onChange="onChange" v-model="model.contactInfo" />

    <FieldInlineText label="לינק למפות גוגל" @onChange="onChange" v-model="model.googleMapLink" />

    <FieldInlineText label="לינק למפות WAZE" @onChange="onChange" v-model="model.wazelink" />

    <b-checkbox @input="onChange" style="gap: 10px" v-model="model.refreshments" label="" type="is-link is-light" class="checkbox">
      כיבוד
    </b-checkbox>

    <b-checkbox @input="onChange" style="gap: 10px" v-model="model.parkingForStudents" label="" type="is-link is-light" class="checkbox">
      חנייה לתלמידים
    </b-checkbox>

    <b-checkbox @input="onChange" style="gap: 10px" v-model="model.parkingForTeacher" label="" type="is-link is-light" class="checkbox">
      חנייה למרצה
    </b-checkbox>

    <b-checkbox @input="onChange" style="gap: 10px" v-model="model.airConditioningControl" label="" type="is-link is-light"
      class="checkbox">
      שליטה במיזוג
    </b-checkbox>

    <b-checkbox @input="onChange" style="gap: 10px" v-model="model.accessForDisabled" label="" type="is-link is-light" class="checkbox">
      גישה לנכים
    </b-checkbox>

    <b-checkbox @input="onChange" style="gap: 10px" v-model="model.cafeteria" label="" type="is-link is-light" class="checkbox">
      קפיטריה
    </b-checkbox>

    <b-checkbox @input="onChange" style="gap: 10px" v-model="model.whiteboard" label="" type="is-link is-light" class="checkbox">
      לוח מחיק
    </b-checkbox>

    <b-checkbox @input="onChange" style="gap: 10px" v-model="model.computer" label="" type="is-link is-light" class="checkbox">
      מחשב
    </b-checkbox>

    <b-checkbox @input="onChange" style="gap: 10px" v-model="model.soundSystem" label="" type="is-link is-light" class="checkbox">
      מערכת הגברה
    </b-checkbox>

    <b-checkbox @input="onChange" style="gap: 10px" v-model="model.projector" label="" type="is-link is-light" class="checkbox">
      מקרן
    </b-checkbox>

    <div class="checkbox-container">
      <b-switch class="ltr" @input="onChange" v-model="model.status">{{
      model.status ? "פעיל" : "לא פעיל"
    }}</b-switch>
    </div>

  </div>
</template>

<script>
import FieldInlineText from '@/components/Fields/FieldInlineText.vue';
// import FieldInlineTextArea from '@/components/Fields/FieldInlineTextArea.vue';
// import FieldInlineDate from '@/components/Fields/FieldInlineDate.vue';
// import FieldInlineDateTime from '@/components/Fields/FieldInlineDateTime.vue';
import FieldInlineSelect from '@/components/Fields/FieldInlineSelect.vue';
import CoursesService from "@/services/CoursesService";
import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'LessonEntityDetails',
  components: {
    FieldInlineText,
    // FieldInlineDate,
    FieldInlineSelect,
    // FieldInlineTextArea,
  },
  props: ['readOnly'],
  data() {
    return {
      model: {
        id: null,
        name: null,
        accessForDisabled: null,
        address: null,
        airConditioningControl: null,
        cafeteria: null,
        capacity: null,
        capacityYellowLine: null,
        city: null,
        computer: null,
        contactInfo: null,
        courseId: null,
        editorNode: null,
        googleMapLink: null,
        lecturesRegionsId: null,
        lecturesRegionName: null,
        openFrom: null,
        openUntil: null,
        parkingForStudents: null,
        parkingForTeacher: null,
        projector: null,
        refreshments: null,
        soundSystem: null,
        status: null,
        tablesTypes: null,
        userNote: null,
        wazelink: null,
        whiteboard: null
      },
    };
  },
  computed: {
    ...mapGetters('lecturesHall', [
      'form',
    ]),
    courseId() {
      return this.$store.state.auth?.course.id;
    },
    changesAmount() {
      return Object.keys(this.diff(this.model, this.form)).length;
    },
  },
  created() {
    this.model = { ...this.model, ...this.form };
  },
  methods: {
    diff(o1, o2) {
      const diff = Object.keys(o2).reduce((diff1, key) => {
        if (o1[key] && typeof o1[key].getMonth === 'function') {
          if (new Date(o1[key]).toString() === new Date(o2[key]).toString()) return diff1;
        }
        if (typeof o1[key] === 'number') {
          if (parseInt(o1[key], 10) === parseInt(o2[key], 10)) return diff1;
        }
        if (o1[key] && typeof o1[key] === 'object' && typeof o1[key].getMonth !== 'function') {
          if (o1[key]?.Id === o2[key]?.Id) return diff1;
        }
        if (o1[key] === o2[key]) return diff1;
        return {
          ...diff1,
          [key]: o2[key],
        };
      }, {});

      return diff;
    },
    onChange() {
      this.$emit('onFormChange', this.changesAmount);
    },
    cancel() {
      this.model = { ...this.model, ...this.form };
    },
    getRegions() {
      return () =>
        CoursesService.getCourseRegions(this.courseId, {
          PageSize: 9999,
          IsAscending: false,
          PageNumber: 1,
          ResultType: 3
        }).then((r) =>
          r.data.items.map((i) => ({ Value: i.id, Text: i.name }))
        );
    },
    save() {
      this.$emit('onFormSave', {
        model: this.model,
        cancel: this.cancel,
        setRestorePoint: this.setRestorePoint,
      });
    },
    setRestorePoint() {
      this.storeLessonDetails(this.model);
    },
    refresh() {
      this.model = { ...this.model, ...this.form };
    },
    ...mapMutations('lecturesHall', [
      'storeLessonDetails',
    ]),
  },
};
</script>

<style lang="scss" scoped>
.checkbox-container {
  display: flex;
  gap: 10px;
  margin-top: 10px;
}
</style>
